import React from "react";

export default function IconSoftwareInstallation() {
  return (
    <svg
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="m59 8h-54a3 3 0 0 0 -3 3v32a3 3 0 0 0 3 3h21v8h-3v2h18v-2h-3v-8h21a3 3 0 0 0 3-3v-32a3 3 0 0 0 -3-3zm1 35a1 1 0 0 1 -1 1h-54a1 1 0 0 1 -1-1v-32a1 1 0 0 1 1-1h54a1 1 0 0 1 1 1z"></path>
      <circle cx="27" cy="27" r="4"></circle>
      <path d="m27 33a6 6 0 1 1 5.32-8.76l3.81-5.08-2.06-2.06-2.29 2.29a8.76 8.76 0 0 0 -2.78-1.16v-3.23h-4v3.23a8.76 8.76 0 0 0 -2.78 1.16l-2.29-2.29-2.83 2.83 2.29 2.29a8.76 8.76 0 0 0 -1.16 2.78h-3.23v4h3.23a8.76 8.76 0 0 0 1.16 2.78l-2.29 2.29 2.83 2.83 2.29-2.29a8.76 8.76 0 0 0 2.78 1.16v3.23h4v-3.23a8.76 8.76 0 0 0 2.78-1.16l2.29 2.29 2.06-2.06-3.81-5.08a6 6 0 0 1 -5.32 3.24z"></path>
      <path d="m38.93 28 .07-.11v-1.78l-.07-.11h-6a5.6 5.6 0 0 1 0 2z"></path>
      <path d="m44 20h-6l-3 4h5l2 3-2 3h-5l3 4h6l3-4h11v-6h-11z"></path>
      <path d="m6 40h2v2h-2z"></path>
      <path d="m10 40h2v2h-2z"></path>
      <path d="m14 40h2v2h-2z"></path>
    </svg>
  );
}
